import React, { useEffect, useState } from 'react';
import { Image, FlatList, Text, View,StyleSheet } from 'react-native';
import Iframe from 'react-iframe'

export default function pagarcomcredito() {

  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch('https://wesleymontaigne.com/controller/api/')
      .then((response) => response.json())
      .then((json) => setData(json))
      .catch((error) => console.error(error))
      .finally(() => setLoading(false));
  }, []);

  return (
    <View style={{ flex: 1,
      backgroundColor: '#01150E',
      alignItems: 'center',
      justifyContent: 'center', }}>
     <Iframe url="https://wesleymontaigne.com/checkout/pagamentocomcredito.php"
        width="100%"
        height="100%"
        id="myId"
        className="myClassname"
        display="initial"
        position="relative"
        frameBorder="0"
        style={{width:'100%',borderBottomWidth:0}
        }/>

  </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#01150E',
    alignItems: 'center',
    justifyContent: 'center',
    
  },
});